var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1359 1.48359C17.5216 0.821319 18.4784 0.821321 18.8641 1.48359L22.6274 7.94483C22.7687 8.18743 23.0055 8.35945 23.2799 8.41887L30.5878 10.0014C31.3369 10.1636 31.6326 11.0735 31.1219 11.645L26.1398 17.2208C25.9528 17.4301 25.8623 17.7085 25.8906 17.9878L26.6438 25.4271C26.721 26.1896 25.947 26.752 25.2457 26.4429L18.4032 23.4277C18.1463 23.3145 17.8537 23.3145 17.5968 23.4277L10.7543 26.4429C10.053 26.752 9.27897 26.1896 9.35617 25.4271L10.1094 17.9878C10.1377 17.7085 10.0472 17.4301 9.86017 17.2208L4.8781 11.645C4.36745 11.0735 4.6631 10.1636 5.41215 10.0014L12.7201 8.41887C12.9945 8.35945 13.2313 8.18743 13.3726 7.94482L17.1359 1.48359Z",
    fill: "url(#paint0_linear_2_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4321 1.73524L22.1954 8.19648C22.4073 8.56038 22.7625 8.81842 23.1741 8.90755L30.482 10.4901C30.8566 10.5712 31.0044 11.0261 30.7491 11.3119L25.767 16.8876C25.4864 17.2017 25.3507 17.6192 25.3932 18.0382L26.1464 25.4775C26.185 25.8587 25.798 26.1399 25.4473 25.9854L18.6049 22.9702C18.2195 22.8003 17.7805 22.8003 17.3951 22.9702L10.5527 25.9854C10.202 26.1399 9.81503 25.8587 9.85363 25.4775L10.6069 18.0382C10.6493 17.6192 10.5136 17.2017 10.233 16.8876L5.25095 11.3119C4.99562 11.0261 5.14345 10.5712 5.51797 10.4901L12.8259 8.90755C13.2375 8.81842 13.5927 8.56038 13.8046 8.19647L17.5679 1.73524C17.7608 1.4041 18.2392 1.4041 18.4321 1.73524Z",
    stroke: "#17243F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_2",
    x: 0.622978,
    y: 0.986885,
    width: 34.754,
    height: 33.5424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: 4.5,
    y1: 10.5,
    x2: 32,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71F2B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#31E7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#00DAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#00CCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21BBEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGradient);
export default __webpack_public_path__ + "static/media/StarGradient.554a005e23eb03fe68ac4aeabba8388e.svg";
export { ForwardRef as ReactComponent };